export const educationData = [
    {
        id: 1,
        institution: 'UW Professional & Continuing Education',
        course: 'Certificate, Full-Stack Web Development',
        startYear: 'April, 2021',
        endYear: 'November, 2021'
    },
    {
        id: 2,
        institution: 'University of Washington School of Oceanography',
        course: 'Bachelor of Science',
        startYear: '2016',
        endYear: '2021'
    }
]